<template>
  <div>
    <!-- <ProductDetail :lineId="lineId" :conveyorId="conveyorId"></ProductDetail> -->
<div class="card card-custom card-stretch gutter-b">
    <div class="card-body p-10">
        <div class="row mb-17">
            <div class="col-md-5 mb-11 mb-xxl-0">
                <!--begin::Image-->
                <div class="card card-custom card-stretch">
                    <div class="card-body p-0 rounded px-10 py-15 d-flex align-items-center justify-content-center" style="background-color: #ffffff;">
                        <img :src=product.url class="mw-150 w-100px">
                    </div>
                </div>
                <!--end::Image-->
            </div>
            <div class="col-md-7 pl-xxl-11">
                <h2 class="font-weight-bolder text-dark mb-5" style="font-size: 20px;">{{ product.name }}</h2>
                <div class="line-height-xl mb-5">{{ product.code }}</div>
                <div class="font-size-h2 mb-5 text-dark-50">{{ $t('ECOMMERCE.PRICE') }} 
                  <span class="/*text-primary*/ font-weight-boldest ml-2" v-if="product.price !== 0">€ {{ product.price }}</span>
                  <a :href="`mailto:?subject=Price request : ${product.category} > ${product.code}&body=Hello,%0D%0DCan I get a quote for this product%0DProduct category : ${product.category}%0DProduct name : ${product.name}%0DProduct code : ${product.code}%0DCompany id : ${companyId}%0D%0DThank you%0D${userName}&cc=${userEmail}`" 
                    class="/*text-primary*/ font-weight-boldest ml-2" v-if="product.price === 0">on request</a>
                </div>
                <div class="text-right">
                <a :href="`#/shop/${product.category}/${product.code}`" @click="RemoveQty" class="btn btn-xs btn-light-success btn-icon mr-2">
                  <i class="ki ki-minus icon-xs"></i>
                </a>
                {{ this.Quantity }} x {{ this.product.minOrderQty }}
                <a :href="`#/shop/${product.category}/${product.code}`" @click="AddQty" class="btn btn-xs btn-light-success btn-icon mr-4">
                  <i class="ki ki-plus icon-xs"></i>
                </a>
                <!-- <button v-if="this.productAdded === true" type="button" class="btn btn-success font-weight-bolder mr-6 px-6 font-size-sm">Product added to cart</button> -->
                  <!-- <input ref="QuoteSubject" class="form-control form-control-lg form-control-solid" type="text" :value="product.minOrderQty" /> -->
                <button @click="AddToCart" class="btn btn-primary font-weight-bolder font-size-sm">
                    <span class="svg-icon svg-icon-md svg-icon-white">
                        <inline-svg src="media/svg/icons/Shopping/Cart2.svg" />
                    </span>
                    {{ this.Quantity * this.product.minOrderQty }} x {{ $t('ECOMMERCE.ADDTOCART') }}
                </button>
                </div>
                <v-alert v-if="this.productAdded === true" type="success" class="mt-5 btn-success">
                  {{ $t('ECOMMERCE.PRODUCT_ADDED') }}
                </v-alert>
            </div>
        </div>
        <div class="row mb-6">
            <!--begin::Info-->
            <div class="col-6 col-md-4" v-if="product.s1 !== ''">
                <div class="mb-8 d-flex flex-column">
                    <span class="text-dark font-weight-bold mb-4">{{ product.labelS1 }}</span>
                    <span class="text-muted font-weight-bolder font-size-lg">{{ product.s1 }}</span>
                </div>
            </div>
            <div class="col-6 col-md-4" v-if="product.s2 !== ''">
                <div class="mb-8 d-flex flex-column">
                    <span class="text-dark font-weight-bold mb-4">{{ product.labelS2 }}</span>
                    <span class="text-muted font-weight-bolder font-size-lg">{{ product.s2 }}</span>
                </div>
            </div>
            <div class="col-6 col-md-4" v-if="product.s3 !== ''">
                <div class="mb-8 d-flex flex-column">
                    <span class="text-dark font-weight-bold mb-4">{{ product.labelS3 }}</span>
                    <span class="text-muted font-weight-bolder font-size-lg">{{ product.s3 }}</span>
                </div>
            </div>
            <div class="col-6 col-md-4" v-if="product.s4 !== ''">
                <div class="mb-8 d-flex flex-column">
                    <span class="text-dark font-weight-bold mb-4">{{ product.labelS4 }}</span>
                    <span class="text-muted font-weight-bolder font-size-lg">{{ product.s4 }}</span>
                </div>
            </div>
            <div class="col-6 col-md-4" v-if="product.s5 !== ''">
                <div class="mb-8 d-flex flex-column">
                    <span class="text-dark font-weight-bold mb-4">{{ product.labelS5 }}</span>
                    <span class="text-muted font-weight-bolder font-size-lg">{{ product.s5 }}</span>
                </div>
            </div>
            <div class="col-6 col-md-4" v-if="product.s6 !== ''">
                <div class="mb-8 d-flex flex-column">
                    <span class="text-dark font-weight-bold mb-4">{{ product.labelS6 }}</span>
                    <span class="text-muted font-weight-bolder font-size-lg">{{ product.s6 }}</span>
                </div>
            </div>
            <div class="col-6 col-md-4">
                <div class="mb-8 d-flex flex-column">
                    <span class="text-dark font-weight-bold mb-4">{{ $t('ECOMMERCE.MINIMUM_QUANTITIY') }}</span>
                    <span class="text-muted font-weight-bolder font-size-lg">{{ product.minOrderQty }}</span>
                </div>
            </div>           
            <!-- <div class="col-6 col-md-4">
                <div class="mb-8 d-flex flex-column">
                    <span class="text-dark font-weight-bold mb-4">Net Profit</span>
                    <span class="text-muted font-weight-bolder font-size-lg">$3,750</span>
                </div>
            </div>           
            <div class="col-6 col-md-4">
                <div class="mb-8 d-flex flex-column">
                    <span class="text-dark font-weight-bold mb-4">Balance</span>
                    <span class="text-muted font-weight-bolder font-size-lg">$68,300</span>
                </div>
            </div> -->
            <!--end::Info-->
        </div>
    </div>
</div>


<div class="card card-custom card-stretch gutter-b">
    <div class="card-body p-10">
      <div class="table-responsive">
        <table
          class="table table-head-custom table-vertical-center"
          id="kt_advance_table_widget_4"
        >
          <thead>
            <tr class="text-left">
              <th class="pl-0" style="width: 55px">{{ $t('TRANSLATOR.STATUS') }}</th>
              <th style="min-width: 55px; max-width: 80px">{{ $t("TRANSLATOR.LINE", { msg: "LINE" }) }}</th>
              <th style="min-width: 140px">
                {{ $t("TRANSLATOR.NAME", { msg: "NAME" }) }}
              </th>
              <th style="min-width: 100px">
                {{ $t("TRANSLATOR.SECTION", { msg: "SECTION" }) }}
              </th>
              <th class="pr-0" style="min-width: 100px">{{ $t("TRANSLATOR.LASTCHECK", { msg: "LASTCHECK" }) }}</th>
              <th
                class="pl-0 text-center"
                style="min-width: 20px; max-width: 40px"
              >
                <span class="label label-lg label-inline label-light-success">
                  <span class="svg-icon">
                    <inline-svg src="media/svg/icons/Navigation/Check.svg" />
                  </span>
                </span>
              </th>
              <th
                class="pl-0 text-center"
                style="min-width: 20px; max-width: 40px"
              >
                <span class="label label-lg label-inline label-light-warning">
                  <span class="svg-icon">
                    <inline-svg
                      src="media/svg/icons/Code/warning-1-circle.svg"
                    />
                  </span>
                </span>
              </th>
              <th
                class="pl-0 text-center"
                style="min-width: 20px; max-width: 40px"
              >
                <span class="label label-lg label-inline label-light-danger">
                  <span class="svg-icon">
                    <inline-svg src="media/svg/icons/Code/Warning-2.svg" />
                  </span>
                </span>
              </th>
            </tr>
          </thead>
          <tbody>
            <template v-for="(item, i) in lineInfo">
              <tr v-bind:key="i">
                <td class="pl-0">
                  <span
                    v-if="item.statusRed === 0 && item.statusOrange === 0"
                    class="label label-lg label-inline label-light-success"
                  >
                    <span class="svg-icon">
                      <inline-svg src="media/svg/icons/Navigation/Check.svg" />
                    </span>
                  </span>
                  <span
                    v-if="item.statusRed === 0 && item.statusOrange > 0"
                    class="label label-lg label-inline label-light-warning"
                  >
                    <span class="svg-icon">
                      <inline-svg
                        src="media/svg/icons/Code/warning-1-circle.svg"
                      />
                    </span>
                  </span>
                  <span
                    v-if="item.statusRed > 0"
                    class="label label-lg label-inline label-light-danger"
                  >
                    <span class="svg-icon">
                      <inline-svg src="media/svg/icons/Code/Warning-2.svg" />
                    </span>
                  </span>
                </td>
                <td>
                  <a
                    v-bind:href="`#/line/${item.lineNumber}/conveyor/${item.conveyorNumber}`"
                    class="text-dark-75 font-weight-bolder text-hover-primary font-size-lg"
                  >
                    {{ item.lineNumber }}
                  </a>
                </td>
                <td>
                  <a
                    v-bind:href="`#/line/${item.lineNumber}/conveyor/${item.conveyorNumber}`"
                    class="text-dark-75 font-weight-bolder text-hover-primary font-size-lg"
                  >
                    {{ item.conveyorNumber }} > {{ item.conveyorExtName }}
                  </a>
                </td>
                <td>
                  <a
                    v-bind:href="`#/line/${item.lineNumber}/conveyor/${item.conveyorNumber}`"
                    class="text-dark-75 font-weight-bolder text-hover-primary font-size-lg"
                  >
                    {{ item.sortOrder }}
                  </a>
                </td>
                <td class="pr-0">
                  <span class="text-muted font-weight-bold">{{
                    item.updated
                  }}</span>
                </td>
                <td class="text-center">
                  <span
                    class="text-dark-75 font-weight-bolder d-block font-size-lg"
                  >
                  </span>
                  <span class="text-muted font-weight-bold">{{
                    item.statusGreen
                  }}</span>
                </td>
                <td class="text-center">
                  <span
                    class="text-dark-75 font-weight-bolder d-block font-size-lg"
                  >
                  </span>
                  <span class="text-muted font-weight-bold">{{
                    item.statusOrange
                  }}</span>
                </td>
                <td class="text-center">
                  <span
                    class="text-dark-75 font-weight-bolder d-block font-size-lg"
                  >
                  </span>
                  <span class="text-muted font-weight-bold">{{
                    item.statusRed
                  }}</span>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
      </div>
      </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import JwtService from "@/core/services/jwt.service";
import axios from "axios";

export default {
  watch: {},
  // name: "conveyor",
  components: {
    // ProductDetail,
  },
  // data() {
  //   return {
  //   }
  // },
  data() {
    return {
      productId: this.$route.params.productId,
      category: this.$route.params.category,
      product: [],
      lineInfo: [],
      Quantity: 1,
      minOrderQty: 1,
      productAdded: false,
      userId: JwtService.authorizeToken().id,
      userName: JwtService.authorizeToken().name,
      userEmail: JwtService.authorizeToken().emailaddress,
      companyId: JwtService.authorizeToken().companyId,
    };
  },
  async mounted() {
    await this.getConveyors();
    await this.getIdenticalLines();
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: `Shop > ${this.category} > ${this.productId}`,
        route: `/shop/${this.category}/`,
        category: this.category,
        productId: this.productId,
      },
    ]);
  },
  methods: {
    async getConveyors() {
      await axios
        // .get("line/" + this.lineId)
        .get("/shop/product/ProductId="+ this.productId +"&Category="+ this.category)
        .then((response) => {
        // console.log(response.data);
        this.product = response.data;
        })
        .catch((err) => {
          throw err;
        });
    },
    async getIdenticalLines() {
      await axios
        .get("/shop/getidenticallines/ProductId="+ this.productId +"&Category="+ this.category)
        .then((response) => {
        // console.log(response.data);
        this.lineInfo = response.data;
        })
        .catch((err) => {
          throw err;
        });
    },
    AddToCart() {
      axios
        .post("shop/addtocart", {
            Category: this.category,
            Code: this.productId,
            Name: this.product.name,
            UserId: this.userId,
            CompanyId: this.companyId,
            Price: this.product.price,
            Quantity: this.Quantity,
            MinOrderQty: this.product.minOrderQty,
            URL: this.product.url,
        })
        .then(() => {
            this.productAdded = true;
            axios.get('/shop/getcart').then(response => {
                // console.log(response.data);
                this.list = response.data;
                this.loading = false;
            })
            .catch((err) => {
              throw err;
            });
        })
        .catch((err) => {
          throw err;
        });
    },
    RemoveQty(){
        this.Quantity --;
    },
    AddQty(){
        this.Quantity ++;
    },
  },
};
</script>